import { render, staticRenderFns } from "./entity-table-provider.vue?vue&type=template&id=715d7e92&scoped=true&"
import script from "./entity-table-provider.ts?vue&type=script&lang=ts&"
export * from "./entity-table-provider.ts?vue&type=script&lang=ts&"
import style0 from "./entity-table-provider.scss?vue&type=style&index=0&id=715d7e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715d7e92",
  null
  
)

export default component.exports